import React from 'react'

import { useIntl } from 'react-intl'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import GroupAddIcon from '@mui/icons-material/GroupAdd'

const ShareLoanEmptyState = () => {
	const { formatMessage } = useIntl()

	return (
		<Paper
			sx={{
				mt: 2,
				p: 4,
				textAlign: 'center',
				backgroundColor: ({ palette }) =>
					palette.mode === 'dark' ? 'grey.800' : 'grey.50',
				border: '2px dashed',
				borderColor: 'grey.300',
			}}
			elevation={0}
		>
			<GroupAddIcon
				sx={{
					fontSize: 48,
					color: 'grey.400',
					mb: 2,
				}}
			/>
			<Typography variant="h6" color="textSecondary" gutterBottom>
				{formatMessage({
					id: 'share_loan.empty_state.title',
				})}
			</Typography>
			<Typography
				variant="body2"
				color="textSecondary"
				sx={{ mb: 2 }}
			>
				{formatMessage({
					id: 'share_loan.empty_state.description',
				})}
			</Typography>
			<Typography
				variant="caption"
				color="textSecondary"
				sx={{ fontStyle: 'italic' }}
			>
				{formatMessage({
					id: 'share_loan.empty_state.hint',
				})}
			</Typography>
		</Paper>
	)
}

export default ShareLoanEmptyState
